export default {
  LOAD_BOOKMARKS (state, payload) {
    state.bookmarks = payload
  },
  LOAD_CAREERS (state, payload) {
    state.careers = payload
  },
  UPDATE_CAREER_FACET_RESULTS (state, payload) {
    state.careerFacetResults = payload
  },
  UPDATE_CAREER_RESULTS (state, payload) {
    state.careerSearchResults = payload
  },
  UPDATE_CAREER_SEARCH_TERMS (state, payload) {
    state.careerSearchTerms = payload
  },
  UPDATE_CAREER_SEARCH_SORT (state, payload) {
    state.careerSearchSort = payload
  },
  UPDATE_CAREER_SEARCH_FILTER (state, payload) {
    state.careerSearchFilter = payload
  },
  UPDATE_CAREER_SEARCH_SELECTED_FACET_NAMES (state, payload) {
    state.careerSearchSelectedFacetNames = payload
  },
  UPDATE_CAREER_SEARCH_INCOME_MIN (state, payload) {
    state.careerSearchCustomIncomeMin = payload
  },
  UPDATE_CAREER_SEARCH_INCOME_MAX (state, payload) {
    state.careerSearchCustomIncomeMax = payload
  },
  ADD_CAREER_SEARCH_SELECTED_FACET_NAMES (state, payload) {
    state.careerSearchSelectedFacetNames.push(payload)
  },
  UPDATE_PROGRAM_GUIDE_RESULTS (state, payload) {
    state.programGuideSearchResults = payload
  },
  UPDATE_PROGRAM_GUIDE_FACET_RESULTS (state, payload) {
    state.programGuideFacetResults = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_TERMS (state, payload) {
    state.programGuideSearchTerms = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_SORT (state, payload) {
    state.programGuideSearchSort = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_FILTER (state, payload) {
    state.programGuideSearchFilter = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_SELECTED_FACET_NAMES (state, payload) {
    state.programGuideSearchSelectedFacetNames = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_INCOME_MIN (state, payload) {
    state.programGuideSearchCustomIncomeMin = payload
  },
  UPDATE_PROGRAM_GUIDE_SEARCH_INCOME_MAX (state, payload) {
    state.programGuideSearchCustomIncomeMax = payload
  },
  LOAD_CURRENT_FACET (state, payload) {
    state.currentFacet = payload
  },
  LOAD_PROGRAM_TOTAL (state, payload) {
    state.programTotal = payload
  },
  LOAD_CAREER_TOTAL (state, payload) {
    state.careerTotal = payload
  },
  LOAD_INSTITUTION_CAREERS (state, payload) {
    state.institutionCareers = payload
  },
  UPDATE_CAREER_SEARCH_INSTITUTION_CAREER_FILTER (state, payload) {
    state.careerSearchInstitutionCareerFilter = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/explore/vuex/mutations.js